import {Component, Input} from '@angular/core';

@Component({
    selector: 'table[tfl-table-additional]',
    template: `
        <ng-content select="thead"></ng-content>
        <ng-content *ngIf="!empty && !loading" select="tbody"></ng-content>
        
        <tbody *ngIf="empty || loading">
            <tr>
                <td [attr.colspan]="columns" class="text-center">
                    <i *ngIf="loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                    <h4 *ngIf="!loading && empty">{{ emptyMessage | translate }}</h4>
                </td>
            </tr>
        </tbody>
    `
})
export class TableAdditionalComponent {
    @Input('empty') empty: boolean = false;
    @Input('loading') loading: boolean = false;
    @Input('columns') columns: number;

    @Input('empty-message') emptyMessage: string = 'COMMON.EMPTY_RESULT';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/table/table.additional.component.ts